module.exports = "<listado-general [listado]=\"availablesProducts\" [titulo]=\"'NewProductSOC' | i18next\"></listado-general>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/product/configurar.component.html
// module id = ../../../../../src/app/private/configuracion/product/configurar.component.html
// module chunks = main